var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronUpArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.77157C0 7.38223 0.145148 6.99557 0.426301 6.73157L7.28369 0.294214C7.70771 -0.10312 8.31344 -0.097787 8.73174 0.308881L15.5891 6.97557C16.0737 7.44623 16.1389 8.28757 15.7354 8.85424C15.332 9.41957 14.6108 9.49557 14.1262 9.02357L7.98772 3.05689L1.8595 8.81024C1.36805 9.27157 0.648023 9.18091 0.252581 8.60624C0.0822887 8.3609 0 8.0649 0 7.77157Z",
    fill: "#696677"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpArrow);
export default __webpack_public_path__ + "static/media/chevron-up-arrow.c738d47e05c1d3d430fb875dbb84fa30.svg";
export { ForwardRef as ReactComponent };